export const ANALYTICS_EVENT_SHARED_FILES_LINKS = {
  VIEW_OPENED: 'shared_files_links_view_opened',
  ITEM_OPENED: 'shared_files_links_item_opened',
} as const;

export const SHARED_ITEMS_PAGE_LIMIT = 50;

export const QUERY_KEY_FETCH_SHARED_ITEMS = 'conversation.fetchSharedItems';

export const SHARED_ITEMS_GRID_COLS =
  'grid-cols-[minmax(0,2fr)_minmax(0,1.5fr)_minmax(0,1fr)]';
